import EducationMasterForm from "./EducationMasterForm";

const EditEducationCategory = () => (
  <EducationMasterForm
    title="Education Category"
    backPath="/all-education-category"
    submitLabel="Update Education Category"
    addEndpoint="/admin/add-education-category"
    getEndpoint="/admin/get-education-category"
    updateEndpoint="/admin/update-education-category"
    responseKey="EducationCategory"
  />
);

export default EditEducationCategory;
